import { TranslatePipe } from '../../filters/translate.pipe';
import { LoaderOverlayComponent } from '../../components/loader-overlay/loader-overlay.component';
import { InputAutocompleteComponent } from '../../components/input-autocomplete/input-autocomplete.component';
import { ItemErrorComponent } from '../../components/item-form-error/item-form-error.component';
import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import RoutingService from '../../services/routing.service';
import Config from '../../utils/config.service';
import Session from '../../utils/session.service';
import BusinessRestServices from '../../services/business-rest.service';
import CategoryService from '../../services/category.service';
import WordCloudService from '../../services/word-cloud.service';
import UserService from '../../services/user.service';
import LanguageService from '../../services/language.service';
import AngularHelperService from '../../services/angular-helper.service';
import AngularFilterHelperService from '../../services/angular-filter-helper.service';
import AngularRoutingHelperService from '../../services/angular-routing-helper.service';
import AngularBroadcastHelperService from '../../services/angular-broadcast-helper.service';
import { Subscription } from 'rxjs';

@Component({
	standalone: true,
	selector: 'booking-mental-check',
	templateUrl: './booking-mental-check.component.html',
	imports: [ CommonModule, TranslatePipe, LoaderOverlayComponent, InputAutocompleteComponent, ItemErrorComponent, FormsModule ]
})
export default class BookingMentalCheckView implements OnInit, OnDestroy {
	private routingService: RoutingService = inject(RoutingService);
	private config: Config = inject(Config);
	private session: Session = inject(Session);
	private businessRestServices: BusinessRestServices = inject(BusinessRestServices);
	private categoryService: CategoryService = inject(CategoryService);
	private wordCloudService: WordCloudService = inject(WordCloudService);
	private userService: UserService = inject(UserService);
	private languageService: LanguageService = inject(LanguageService);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	private angularFilterHelperService: AngularFilterHelperService = inject(AngularFilterHelperService);
	private angularRoutingHelperService: AngularRoutingHelperService = inject(AngularRoutingHelperService);
	private angularBroadcastHelperService: AngularBroadcastHelperService = inject(AngularBroadcastHelperService);
	
	vm: any = undefined;
	walletSubscription: Subscription = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		this.vm.isProcessing = true;
		this.routingService.validateAccess('booking').then(() => {
			var rawData: any = window.sessionStorage.getItem(this.config.getBookingConfig().Instant.STORAGE_KEY);
			var booking: any = rawData ? JSON.parse(rawData) : {};
			var origin: any = this.angularRoutingHelperService.getQueryParam('origin');
			
			if (booking && booking.service) {
				this.onResolve();
			} else {
				if (!origin) {
					var userSession = this.session.getSession();
					origin = (userSession && userSession.user && userSession.user.origin) ? userSession.user.origin : 'minudoc.ee';
				}
				
				var params: any = {
					origin: origin
				};
				this.businessRestServices.getOnDemandSettings(params, (settings) => {
					this.onResolve(settings);
				});
			}
			
		});
	}
	
	ngOnDestroy() {
		if (this.walletSubscription) {
			this.walletSubscription.unsubscribe();
		}
	}
	
	onResolve(settings?) {
		this.vm.user = this.session.getSession().user;
		this.vm.origin = this.session.getSession().user.origin;
		this.vm.serviceId = this.angularRoutingHelperService.getQueryParam('serviceId');
		this.vm.isOutOfHoursMode = !!this.vm.serviceId;
		this.vm.storageKey = this.config.getBookingConfig().Instant.STORAGE_KEY;
		this.vm.problemMaxLength = 300;
		this.vm.questionnaireId = 0;
		this.vm.question = '';
		this.vm.answers = [];
		this.vm.isInputTextAreaShown = false;
		this.vm.hasIiziBusinessWallet = false;
		this.vm.step = this.angularRoutingHelperService.getQueryParams()['step'];
		this.vm.isSiffi = (this.vm.origin == 'siffi.com');
		this.vm.languages = [];
		this.vm.textColor = (this.vm.isSiffi ? '' : 'c-text--gray');
		
		this.setTitle();
		this.checkStep();
		this.loadLanguages();
		this.loadWordCloud();
		this.loadServiceCategory();
		this.loadServiceOndemandSettings(settings);
		this.loadWallet();
		
		this.vm.toggleConsultantForm = this.toggleConsultantForm;
		this.vm.goToFollowUpHistory = this.goToFollowUpHistory;
		this.vm.handleFormSubmit = this.handleFormSubmit;
		this.vm.onAnswerClick = this.onAnswerClick;
		this.vm.getBusinessWalletLabel = this.getBusinessWalletLabel;
		this.vm.handleLanguageSearch = this.handleLanguageSearch;
		this.vm.handleLanguageSelect = this.handleLanguageSelect;
		this.vm.clearLanguageSearch = this.clearLanguageSearch;
		
		// this.angularStateHelperService.scopeWF(this, this.userService.getWallet, this.handleWalletUpdate, true);
		this.walletSubscription = this.angularBroadcastHelperService.onEvent(this, "walletChanged", (event, newWallet) => {
			this.handleWalletUpdate(newWallet);
		});
		this.userService.getWallet(); // TODO ANGULAR_2: should this be inside an interval?
	}
	
	loadServiceOndemandSettings(settings) {
		this.vm.settings = settings.filter((item) => {
			return item.subcategory === 'GENERAL_MEDICAL_PRACTICE' && item.furtherSubcategory === 'MENTAL_CHECK';
		})[0] || {};
		
		this.vm.price = typeof this.vm.settings.price !== 'undefined'
			? this.vm.settings.price
			: this.config.getBookingConfig().Instant.Doctor.DEFAULT_PRICE;
		this.vm.currency = this.config.getBookingConfig().Instant.Doctor.DEFAULT_CURRENCY;
		this.vm.duration = this.vm.settings.timePerPrice;
	}
	
	loadServiceCategory() {
		this.categoryService.getAll().then((categories) => {
			this.vm.category = categories.filter((category) => {
				return category.subcategory === 'PSYCHOLOGY' && category.furtherSubcategory === 'PSYCHOLOGIST';
			})[0];
		});
	}
	
	loadLanguages() {
		this.languageService.getLanguageRatings().subscribe((response: any) => {
			this.vm.languages = response.map((item) => {
				item.countryCode = item.flagCountryCode;
				return item;
			});
			this.vm.languages.forEach((item) => {
				if (item['languageCode'] === this.vm.user.deviceLanguage.split('_')[0]) {
					this.vm.primaryLanguage = this.angularHelperService.copy(item);
				}
			});
			this.vm.isInitialized = true;
		});
	}
	
	loadWordCloud() {
		this.wordCloudService.getQuestionnaire().then((questionnaire) => {
			this.vm.questionnaireId = questionnaire.id;
			this.vm.question = questionnaire.questions[0].translation['translationText'];
			questionnaire.questions[0]['answers'].map((answer) => {
				if (answer.id && answer.defaultText && answer.translation) {
					this.vm.answers.push({
						id: answer.id,
						defaultText: answer.defaultText,
						text: answer.translation['translationText'],
						isSelected: false
					})
				}
			});
			this.vm.isProcessing = false;
		});
	}
	
	loadWallet() {
		this.userService.getWalletWithPrice({ pricing: { price: this.vm.price }, furtherSubcategory: this.vm.settings.furtherSubcategory })
			.then((usedWallet) => {
				if (usedWallet.alternative) {
					if (usedWallet.coPayWallet) {
						this.vm.walletName = usedWallet.coPayWallet.wallet.name;
						this.vm.insuranceCoPay = true;
					} else {
						this.vm.walletName = usedWallet.wallet.name;
					}
				}
				this.vm.isCoveredByBusinessWallet = this.vm.price && (!usedWallet.price || usedWallet.coPayWallet);
			})
			.catch((e) => {
				console.error(e);
			});
	}
	
	handleWalletUpdate(wallet) {
		if (this.angularHelperService.equals(wallet, this.vm.wallet)) return;
		this.vm.wallet = wallet || {};
		var hasIiziBusinessWallet: any = (this.vm.wallet['alternatives'] || []).find((wallet) => {
			var isInsuranceType: any = (wallet['walletType'] || '').toLowerCase() === 'insurance';
			var isIiziPackageName: any = (wallet['name'] || '').toLowerCase() === 'iizi';
			return (isInsuranceType && isIiziPackageName);
		});
		if (hasIiziBusinessWallet) {
			this.vm.hasIiziBusinessWallet = true;
		}
	}
	
	getBusinessWalletLabel() {
		if (this.vm.insuranceCoPay) {
			return 'Services.Other.Insurance_Cover';
		} else if (this.vm.walletName?.toLowerCase() === 'iizi') {
			return 'Services.Other.Package_By';
		} else {
			return 'Services.Other.Covered_By';
		}
	}
	
	setTitle() {
		this.vm.title = this.vm.showConsultantForm
			? this.vm.question
			: this.angularFilterHelperService.translate('Booking.Instant.Choose_Action');
	}
	
	checkStep() {
		if (this.vm.step === 'CONSULTANT') {
			this.toggleConsultantForm();
		}
	}
	
	handleFormSubmit(mainForm: any) {
		this.vm.submitted = true;
		
		var problems: any = (this.vm.answers.filter((item) => {
			return item.isSelected;
		}) || []).map((item) => {
			return item.text;
		});
		
		if (problems.length === 0) {
			this.vm.nothingSelected = true;
		} else {
			this.vm.nothingSelected = false;
		}
		
		if (!this.vm.isOutOfHoursMode) {
			if (!this.vm.primaryLanguage) {
				this.vm.noPrimaryLanguage = true;
			} else {
				this.vm.noPrimaryLanguage = false;
			}
		}
		
		if (mainForm.invalid || this.vm.nothingSelected || this.vm.noPrimaryLanguage) {
			return;
		}
		
		if (this.vm.isProcessing) return;
		this.vm.isProcessing = true;
		
		var selectedItemIds: any = this.vm.answers
			.filter((answer) => {
				return answer.isSelected
			})
			.map((answer) => {
				return answer.id
			});
		
		var queryParams = {
			'selectedItem': selectedItemIds,
			'primaryLanguage': this.vm.primaryLanguage['languageCode']
		};
		
		if (this.vm.problem) {
			queryParams['problem'] = this.vm.problem;
		}
		
		if (this.vm.isOutOfHoursMode) {
			queryParams['serviceId'] = this.vm.serviceId;
		}
		
		this.angularRoutingHelperService.setPath('/booking/intermediate-dialog', false, false, queryParams);
	}
	
	toggleConsultantForm() {
		this.vm.showConsultantForm = !this.vm.showConsultantForm;
		this.setTitle();
	}
	
	goToFollowUpHistory() {
		this.angularRoutingHelperService.setPath('/history');
	}
	
	onAnswerClick($event, answer) {
		this.vm.answers = this.vm.answers.map((item) => {
			if (item.defaultText === answer.defaultText) {
				item.isSelected = !item.isSelected;
			}
			return item;
		});
		
		var problems: any = (this.vm.answers.filter((item) => {
			return item.isSelected;
		}) || []).map((item) => {
			return item.text;
		});
		if (problems.length === 0) {
			this.vm.nothingSelected = true;
		} else {
			this.vm.nothingSelected = false;
		}
		
		this.vm.isInputTextAreaShown = !!this.vm.answers.find((item) => {
			return ('other' === item.defaultText.toLowerCase()) && item.isSelected;
		});
	}
	
	handleLanguageSearch = (searchParams: any): any => {
		var namePart = searchParams.namePart;
		
		var languages: any = this.vm.languages.filter((language) => {
			return language.name.toLowerCase().indexOf(namePart.toLowerCase()) !== -1
				|| language.languageCode.toLowerCase().indexOf(namePart.toLowerCase()) !== -1
				|| language.flagCountryCode.toLowerCase().indexOf(namePart.toLowerCase()) !== -1;
		});
		
		var deferred: any = this.angularHelperService.getDeferredPromise();
		deferred.resolve(languages.slice(0, languages.length < 10 ? languages.length : 10));
		return deferred.promise;
	}
	
	handleLanguageSelect = (selection: any): void => {
		this.vm.primaryLanguage = this.angularHelperService.copy(selection.selectedItem);
		this.vm.noPrimaryLanguage = false;
	}
	
	clearLanguageSearch = (): void => {
		this.vm.primaryLanguage = undefined;
	}
	
}